import React, { useEffect, useRef } from 'react';
import MenuProps from './Menu.types';
import MenuWrapper from './Menu.style';

const Menu = (props: MenuProps) => {
  const {
    children,
    show = false,
    close = () => {},
    className,
    ...rest
  } = props;

  const ref = useRef();

  const handleClick = () => {
    if (ref.current.offsetParent !== null) {
      close();
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClick);

    return () => {
      window.removeEventListener('click', handleClick);
    };
  });

  return (
    <MenuWrapper
      isOpen={show}
      role="dialog"
      className={`Menu ${className ? className : ''}`}
      ref={ref}
      {...rest}
    >
      <div className="Menu-inner">
        {children}
      </div>
    </MenuWrapper>
  );
};

export default Menu;
